module.exports = __webpack_public_path__ + "static/img/purely.d84503f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand-culture/purely.png
// module id = VNyy
// module chunks = 1